export var Name = 'share-item-click';
export var ShareItemClick = Name;